import { uniqueId } from 'lodash';
import { LayoutChapter } from './ChapterLayout';
import Subchapter, { TempSubChapter } from './Subchapter';
import { Temp } from './Temp';

export default class Chapter {
  id!: number;
  title: string = '';
  book!: number;
  content?: string;
  order!: number;
  layout?: LayoutChapter;
  items?: Subchapter[] | TempSubChapter[];

  constructor(chapter?: Partial<Chapter>) {
    Object.assign(this, chapter);
  }
}

export class TempChapter extends Chapter implements Temp {
  tempId?: string = uniqueId();

  constructor(tempChapter?: Partial<TempChapter>) {
    super();
    Object.assign(this, tempChapter);
  }
}

export function instanceOfChapter(object: any): object is Chapter {
  return (
    'id' in object &&
    'title' in object &&
    'book' in object &&
    'content' in object &&
    'order' in object
  );
}
